import { render, staticRenderFns } from "./Action.vue?vue&type=template&id=283703a8&scoped=true"
import script from "./Action.vue?vue&type=script&lang=js"
export * from "./Action.vue?vue&type=script&lang=js"
import style0 from "./Action.vue?vue&type=style&index=0&id=283703a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283703a8",
  null
  
)

export default component.exports